import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS, CONTENT_VIDEOS_SKU } from '../const.config';

// Videos module configurations
export const LISTING_COLUMNS = [
  {
    id: 'transmissionOrgan',
    label: `${CONTENT_VIDEOS_SKU.ALIAS_SINGULAR}`,
    width: '15%',
    align: 'left',
    dataKey: 'transmissionOrgan',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'transmissionOrganSKU',
    label: `${CONTENT_VIDEOS_SKU.ALIAS_SINGULAR} SKU`,
    width: '15%',
    align: 'left',
    dataKey: 'transmissionOrganSKU',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '15%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
  },
  {
    action: ACTIONS.TRANSLATE.value,
    label: ACTIONS.TRANSLATE.label,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'name',
    label: `${CONTENT_VIDEOS_SKU.ALIAS_SINGULAR}`,
    dataKey: 'name',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'sku',
    label: `${CONTENT_VIDEOS_SKU.ALIAS_SINGULAR} SKU`,
    dataKey: 'sku',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
